module.exports = __webpack_public_path__ + "static/img/icon-regonline.99a3a0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/icon-regonline.png
// module id = DXmL
// module chunks = 15